import React from 'react'
import styled from '@emotion/styled'
import {PreferencesWidgetWithStore} from 'components/PreferencesWidgetWithStore'
import UserWidgetWithStore from 'components/UserWidgetWithStore'

import {NavBar} from '@vio/atlas/NavBar'
import {cssTheme} from '@vio/atlas/themes'
import {useBrand} from '@vio/core/src/_web/brand/hooks/useBrand'
import {Page} from '@vio/core/src/analytics/types/Events'
import {SourceComponentType} from '@vio/core/src/auth/types/Auth'
import {NavBarBrandLogo} from '@vio/shared/src/navBar'
import {BrandLogo} from '@vio/shared/src/whiteLabel/BrandLogo/BrandLogo'

interface Props {
  /** Disable the default logo click which redirects to home */
  disableLogoClick: boolean
  disablePreferences: boolean
  hasCurrencySelector?: boolean
  hasUserWidget: boolean
  hideMyBookings?: boolean
  hideManageAccount?: boolean
  page?: Page
  onCurrencyChange?: (currency: string) => void
}

const EndContentWrapper = styled('div')`
  display: flex;
  gap: ${cssTheme.layout.spacing.s300};
  align-items: inherit;
`

export const DesktopHeader = ({
  disableLogoClick,
  disablePreferences,
  hasCurrencySelector,
  page,
  hasUserWidget = true,
  hideMyBookings = false,
  hideManageAccount = false,
  onCurrencyChange
}: Props) => {
  const {brand, brandSiteAddress} = useBrand()

  const isPaymentPage = page === Page.Payment

  return (
    <NavBar
      withDivider
      startContent={
        <NavBarBrandLogo
          brand={brand}
          disableLogoClick={disableLogoClick}
          BrandLogoComponent={BrandLogo}
          logoUrl={brandSiteAddress}
        />
      }
      endContent={
        <EndContentWrapper>
          {!disablePreferences && (
            <PreferencesWidgetWithStore
              hasLanguage={!isPaymentPage}
              hasCurrency={hasCurrencySelector}
              onCurrencyChange={onCurrencyChange}
            />
          )}
          {hasUserWidget && (
            <UserWidgetWithStore
              hideMyBookings={hideMyBookings}
              hideManageAccount={hideManageAccount}
              referralComponent={
                isPaymentPage ? SourceComponentType.PaymentPage : undefined
              }
            />
          )}
        </EndContentWrapper>
      }
    />
  )
}
